import React from "react";

const Emoji = ({ size, code }) => (
	<img src={`./emojis/${code}.png`} alt="" style={{ width: size + 'px' }} />
);

Emoji.defaultProps = {
	size: 32,
};

export default Emoji;
